import ClientBase from "@/clients/ClientBase";
import DualloUserViewModel from "@/domain/DualloUserViewModel";

class DualloUserClient extends ClientBase {
    async getUserAsync(organizationId, userId) {
        const data = await this.get(`api/v1/duallousers/organizations/${organizationId}/${userId}`);
        return data ? new DualloUserViewModel(data) : null;
    }

    async updateUserRecord(record) {
        const data =  await this.put(`api/v1/duallousers/organizations/${record.organizationId}/${record.id}`, record);
        return data ? new DualloUserViewModel(data) : null;
    }

    async generateSaSToken(organizationId, userId) {
        return await this.post(`api/v1/duallousers/organizations/${organizationId}/${userId}/sas-token`);
    }
}

export default new DualloUserClient();